<script>
  export let show = false;
  const hide = () => show = false;
  const display = () => show = true;
  const toggle = () => show = !show;
</script>

<div class="modal" class:hidden={!show} on:click={hide}>
  <slot></slot>
</div>

<style>
  .hidden {
    display: none;
    pointer-events: none;
  }

  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-content {
    border-radius: 4px;
    padding: 21px;
    position: relative;
    background-color: white;
    opacity: 1.0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
    text-align: center;
  }
</style>
